export enum Theme {
  light = 'light',
  dark = 'dark',
}

export type Themes = Theme.light | Theme.dark;

export interface IColorMap {
  [key: string]: string;
}

export interface IFontMap {
  [key: string]: string;
}

export interface IThemeEntity {
  colors?: IColorMap;
  fonts?: IFontMap;
}
export interface IThemeCustomization {
  dark?: IThemeEntity;
  light?: IThemeEntity;
}
